export const GET_DELIVERY = 'GET_DELIVERY';
export const DELIVERY_FETCH_ERROR = 'DELIVERY_FETCH_ERROR';
